export default {
    state: {
        mode: null,
        all: [],
        filtered: [],
        expenseTypes: {},
        selectedExpenseId: null,
        selectedExpense: {},

    },
    actions: {
        loadExpenseTypes({ commit }) {
            axios.get('/api/expense-types').then(types => {
                commit('setExpenseTypes', types)
            }).catch(response => {
                console.error(response);
            });
        },

        createExpense({ state }, data) {
            state.mode = 'create';

            state.all.push({
                id: 'new',
                expensable_id: data.expensableId,
                expensable_type: data.expensableType,
                type_id: '',
                frequency: '',
                amount_in_dollars: '$0',
                note: ''
            });

            state.selectedExpenseId = 'new';
        },

        editExpense({ state }, expenseId) {
            state.selectedExpenseId = expenseId;
        },

        async save({ state }) {
            let url = state.selectedExpenseId == "new" ? '/expenses' : '/expenses/' + state.selectedExpenseId;

            let data = this.getters.selectedExpense;
            data._method = state.selectedExpenseId == "new" ? "POST" : "PATCH";
            data.amount = Number.prototype.cleanseFloat(data.amount_in_dollars) * 100;

            await axios.post(url, data).then((response) => {
                state.all = _.remove(state.all, expense => { return expense.id != 'new' });
                state.all = _.remove(state.all, expense => { return expense.id != response.data.expense.id });
                state.all.push(response.data.expense);
                state.mode = null;
                state.selectedExpenseId = null;
            }).catch((error) => {
                console.log(error);
            });
        },

        async deleteExpense({ state, dispatch }, expenseId) {
            await axios.delete('/expenses/' + expenseId)
                .then((response) => {
                    dispatch('removeExpense', expenseId);
                })
                .catch((error) => {
                    console.log(error);
                }
            );
        },

        removeExpense({ state }, expenseId) {
            state.all = _.remove(state.all, (expense) => { return expense.id != expenseId });
        }
    },
    mutations: {
        setExpenseTypes(state, types) {
            state.expenseTypes = types.data
        },

        setExpenses(state, expenses) {
            state.all = expenses.data
            state.filtered = expenses.data
        },
    },
    getters: {
        selectedExpense: (state) => {
            return _.find(state.all, ['id', state.selectedExpenseId]);
        }
    }
};